// /client/src/components/IdentifyResistance.js
import React from 'react';
import NavigationPdfs from './NavigationPdfs';
import FooterPdfs from './FooterPdfs';

const IdentifyResistance = () => {
  return (
    <>
      <div className="fullHeight is-flex is-flex-direction-column is-align-items-center is-justify-content-space-between">
        <div className='fullWidth'>
            <NavigationPdfs />
            <div className="pt-2 columns is-centered">
                <div className="column is-6-tablet is-5-desktop is-5-widescreen">
                    <div className="px-4 py-5">
                        <h1 className="h1 colorBlack is-bold">Identify Resistance</h1>
                        <h2 className='h2 is-bold'>Introduction</h2>
                        <p className="pb-4 colorBlack">
                            When you identify resistance, you are working with elements that may be slowing you down or interfering with your ability to reach your goal, To engage with this practice, we will introduce you to a tool called the Wheel of Resistance. Learning to tease apart the often invisible elements that make it difficult for you to move forward can be transformative.
                        </p>
                        <p className="pb-4 colorBlack">
                            Click the download button below to view the optional reading. 
                        </p>
                        <div className="py-5 field">
                            <a 
                                href="/pdfs/next-move-identify-resistance.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button"
                                download
                            >
                                Download PDF
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <FooterPdfs />
      </div>
    </>
  );
};

export default IdentifyResistance;